export const CREATE_NEW_THREAD = {
  STARTED: 'CREATE_NEW_THREAD_STARTED',
  SUCCEEDED: 'CREATE_NEW_THREAD_SUCCEEDED',
  FAILED: 'CREATE_NEW_THREAD_FAILED'
};